import GastroInserzioneVideocapuslaList from "./pages/GastroInserzioneVideocapuslaList.vue"
import GastroInserzioneVideocapuslaView from "./pages/GastroInserzioneVideocapuslaView.vue"
import GastroInserzioneVideocapuslaEdit from "./pages/GastroInserzioneVideocapuslaEdit.vue"

export default{
    GastroInserzioneVideocapuslaList,
    GastroInserzioneVideocapuslaView,
    GastroInserzioneVideocapuslaEdit
}
